/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leads_TitleInputs */

const cs_leads_title = /** @type {(inputs: Leads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leady`)
};

const en_leads_title = /** @type {(inputs: Leads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leads`)
};

/**
* | output |
* | --- |
* | "Leads" |
*
* @param {Leads_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const leads_title = /** @type {((inputs?: Leads_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leads_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_leads_title(inputs)
	return cs_leads_title(inputs)
});